import { getDomain } from "./getDomain";

export const getApiUrl = () => {
  const domainWithSubdomen = getDomain(true);

  let apiUrl = process.env.REACT_APP_API_URL;

  if (domainWithSubdomen === "cloud.frontassist.eu") {
    apiUrl = process.env.REACT_APP_FRONTASSIST_API_URL;
  }

  return apiUrl;
};
